<div [ngClass]="{'rounded mt-3 p-2 bg-light': true, 'border-danger': ruleForm.invalid}">
  <div class="col col-12">

    <div class="row ms-0 me-0">
      <div class="col col-10">
        <form [formGroup]="ruleForm">
          <div class="row">
            <div class="col-lg col-lg-4 p-0 pe-2">
              <ng-select
                [items]="fields"
                (change)="onChangeVariable($event)"
                [formControl]="ruleFieldControl">
              </ng-select>
            </div>

            <div class="col-lg col-lg-2 p-0 pe-2">
              <ng-select
                [items]="operators"
                [formControl]="ruleOperatorControl">
              </ng-select>
            </div>

            <div class="col-lg col-lg-3 p-0 pe-2">
              <ng-select
                [items]="values"
                [formControl]="ruleValueControl">
              </ng-select>
            </div>
          </div>
        </form>
      </div>

      <div class="col col-2">
        <div class="row">
          <div class="col-lg col-lg-12 p-0">
            <button
              type="button"
              class="btn btn-outline-danger float-lg-end mt-1"
              (click)="onRemoveRule()">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
